import { useMutation, useQueryClient } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useRemoveFromShelf() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (entryId: string) => libraryApi.removeFromShelf(entryId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['shelf'] });
      void queryClient.invalidateQueries({ queryKey: ['upcoming'] });
    },
  });
}
